module.exports = __webpack_public_path__ + "static/media/home_zz2.192dc299.png";